import React from 'react';
import { MuiFormBuilder } from 'components';

import uiSchema from './uiSchema';
import schema from './schema';
import { useSelector } from 'react-redux';

const Form = ({ init, setFilter }) => {
  const formData = { ...init };

  const onChange = ({ formData }) => {
    setFilter(formData);
  };

  const { userRoles } = useSelector((state) => state.models);
  const { userStatuses } = useSelector((state) => state.models);
  const { userTypes } = useSelector((state) => state.models);

  return (
    <MuiFormBuilder
      showSubmit={false}
      formContext={{ clearable: true }}
      schema={schema(userRoles, userStatuses, userTypes)}
      uiSchema={uiSchema()}
      formData={formData}
      onChange={onChange}
    />
  );
};

export default Form;
